import styled from "styled-components";

export const RolesAndGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RoleAndGroupTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.black};
  margin: 16px 0 8px 0px;

  & .subtitle {
    color: ${props => props.theme.colors.greyFour};
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const StepperContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
`;